import { useEffect, useState } from "react";
import { Form, Modal } from 'react-bootstrap';
import SrvButton from '../../../../components/global/SrvButton';
import SrvButtonLink from '../../../../components/global/SrvButtonLink';
import { FileUploader } from "react-drag-drop-files";
import WidgetFileItemEdit from './WidgetFileItemEdit';
import { useSelector } from 'react-redux';
import WidgetFileItem from './WidgetFileItem';
import immutabilityUpdate from 'immutability-helper'
import BlockName from '../BlockName';
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import ErrorAdd from "../../../../util/ErrorAdd";

function WidgetFile({ idTask, idWidget, number, idObject, onlyRead, name, nameChange, showTracker, showTrackerChange, widgetUpdateHandler, added }) {

    const stateData = useSelector((state) => state.widgetData);//Данные для виджета

    const [edit, setEdit] = useState(false);
    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(null);
    const [files, setFiles] = useState([]);
    //    const [widgetName, setWidgetName] = useState(null);

    /*
        files:
            ID_Board_Task 
            Widget_Number 
            ID_File 
            ID_Type 
            Name 
            Path 
            Order 
            Size
            Status: 1-Новый, 2-Изменен, 3-Удален
    */

    useEffect(() => {
        setFiles([...stateData.dataFile].filter(a => a.Widget_Number === number).sort((a, b) => a.Order - b.Order).map((item, i) => {
            //return { ...item, temp_id: i };
            return { ID_File: item.ID_File, Name: item.Name, ID_Type: item.ID_Type, Order: item.Order, temp_id: i };
        }))


    }, [stateData.dataFile]);
    useEffect(() => {
        if (added !== null & added !== undefined) {
            //Ограничение на добавление виджета определенного номера. Иначе открываются сразу все виджеты
            if (added.idWidget === idWidget & added.number === number) {
                setEdit(true);
            }
        }
    }, [added]);

    //Событие выбора файла
    function changeFileHandler(data) {

        if (data.length > 0) {
            const count = files.length;

            const fileMass = Array.from(data).map((item, index) => {
                const ext = item.name.split('.').pop();
                const name = item.name.replace('.' + ext, '');

                return {
                    ID_Task: idTask,
                    Widget_Number: number,
                    ID_File: null,
                    ID_Type: null,
                    Name: name,
                    Path: item.name,
                    Order: (count + index),
                    File: data[index],
                    Size: item.size,
                    Status: 1, //Помечаем файл как новый. Для отбора по загрузке
                    temp_id: (count + index)
                }
            })
            setFiles([...files, ...fileMass]);
            // setFilesRow(data);
        }
    }
    //Событие изменения названия файла
    function changeNameHandler(index, val) {
        setFiles(files.map((item, i) => {
            if (index === i) {
                if (item.Status === 1) {
                    return { ...item, Name: val };
                }
                else {
                    return { ...item, Name: val, Status: 2 };
                }
            }
            else {
                return item;
            }
        }))
    }
    //Событие удаления файла
    function changeRemoveHandler(index) {
        setFiles(files.map((item, i) => {
            if (i === index) {
                return { ...item, Status: 3 };
            }
            else {
                return item;
            }
        }))
    }
    //Событие восстановления удаленного файла
    function changeRemoveCancelHandler(index) {

        setFiles(files.map((item, i) => {
            if (index === i) {
                if (item.ID_File === null) {
                    return { ...item, Status: 1 };
                }
                else {
                    return { ...item, Status: 2 };
                }
            }
            else {
                return item;
            }
        }))
    }
    //Сохранит изменения
    function updateHandler() {
        setLoading(true);

        const files_add = files.filter(a => a.Status === 1);
        const files_update = files.filter(a => a.Status === 2);
        const files_remove = files.filter(a => a.Status === 3);

        if (idObject === 1) {
            //Добавляем файлы
            for (let i = 0; i < files_add.length; i++) {

                var formData = new FormData();
                formData.append('ID_Task', idTask);
                formData.append('Widget_Number', number);
                formData.append('File', files_add[i].File);
                formData.append('Name', files_add[i].Name);
                formData.append('Order', files_add[i].Order);

                axios.post('/api_tracker/task/widgetFileUpload', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                    .then((res) => {
                        if (res.data.Status === 1) {

                        }
                        else {
                            setLog(res.data.Error);
                            setLoading(false);
                        }
                    })
                    .catch((err) => {
                        setLog('Неизвестная ошибка!');
                        setLoading(false);
                        ErrorAdd(err, window.location.href);
                    });
            }
            //Обновляем файлы
            for (let i = 0; i < files_update.length; i++) {
                axios.post('/api_tracker/task/widgetFileUpdate', { ID: files_update[i].ID_File, Name: files_update[i].Name, ID_Task: idTask })
                    .then((res) => {
                        if (res.data.Status === 1) {

                        }
                        else {
                            setLog(res.data.Error);
                            setLoading(false);
                        }
                    })
                    .catch((err) => {
                        setLog('Неизвестная ошибка!');
                        setLoading(false);
                        ErrorAdd(err, window.location.href);
                    });
            }
            //Удаляем файлы
            for (let i = 0; i < files_remove.length; i++) {
                axios.post('/api_tracker/task/widgetFileRemove', { ID: files_remove[i].ID_File, ID_Task: idTask })
                    .then((res) => {
                        if (res.data.Status === 1) {

                        }
                        else {
                            setLog(res.data.Error);
                            setLoading(false);
                        }
                    })
                    .catch((err) => {
                        setLog('Неизвестная ошибка!');
                        setLoading(false);
                        ErrorAdd(err, window.location.href);
                    });
            }
            //Обновление сортировки
            const items = files.filter(a => a.ID_File !== null).map((item) => { return { ID_File: item.ID_File, Order: item.Order } })

            axios.post('/api_tracker/task/widgetFileOrderChange', { ID_Task: idTask, Widget_Number: number, Items: items })
                .then((res) => {
                    if (res.data.Status === 1) {

                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });

            setLoading(false);
            setEdit(false);
        }
        if (idObject === 2) {
            //Добавляем файлы
            for (let i = 0; i < files_add.length; i++) {

                var formData = new FormData();
                formData.append('ID_TaskR', idTask);
                formData.append('Widget_Number', number);
                formData.append('File', files_add[i].File);
                formData.append('Name', files_add[i].Name);
                formData.append('Order', files_add[i].Order);

                axios.post('/api_tracker/taskR/widgetFileUpload', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                    .then((res) => {
                        if (res.data.Status === 1) {

                        }
                        else {
                            setLog(res.data.Error);
                            setLoading(false);
                        }
                    })
                    .catch((err) => {
                        setLog('Неизвестная ошибка!');
                        setLoading(false);
                        ErrorAdd(err, window.location.href);
                    });
            }
            //Обновляем файлы
            for (let i = 0; i < files_update.length; i++) {
                axios.post('/api_tracker/taskR/widgetFileUpdate', { ID_TaskR: files_update[i].ID_File, Name: files_update[i].Name, ID_TaskR: idTask })
                    .then((res) => {
                        if (res.data.Status === 1) {

                        }
                        else {
                            setLog(res.data.Error);
                            setLoading(false);
                        }
                    })
                    .catch((err) => {
                        setLog('Неизвестная ошибка!');
                        setLoading(false);
                        ErrorAdd(err, window.location.href);
                    });
            }

            //Удаляем файлы
            for (let i = 0; i < files_remove.length; i++) {
                axios.post('/api_tracker/taskR/WidgetFileRemove', { ID_TaskR: files_remove[i].ID_File, ID_TaskR: idTask })
                    .then((res) => {
                        if (res.data.Status === 1) {

                        }
                        else {
                            setLog(res.data.Error);
                            setLoading(false);
                        }
                    })
                    .catch((err) => {
                        setLog('Неизвестная ошибка!');
                        setLoading(false);
                        ErrorAdd(err, window.location.href);
                    });
            }

            //Обновление сортировки
            const items = files.filter(a => a.ID_File !== null).map((item) => { return { ID_File: item.ID_File, Order: item.Order } })

            axios.post('/api_tracker/taskR/widgetFileOrderChange', { ID_TaskR: idTask, Widget_Number: number, Items: items })
                .then((res) => {
                    if (res.data.Status === 1) {

                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });

            setLoading(false);
            setEdit(false);
        }
        if (idObject === 3) {
            //Добавляем файлы
            for (let i = 0; i < files_add.length; i++) {

                var formData = new FormData();
                formData.append('ID_Board_Task', idTask);
                formData.append('Widget_Number', number);
                formData.append('File', files_add[i].File);
                formData.append('Name', files_add[i].Name);
                formData.append('Order', files_add[i].Order);

                axios.post('/api_tracker/board/taskWidgetFileUpload', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                    .then((res) => {
                        if (res.data.Status === 1) {

                        }
                        else {
                            setLog(res.data.Error);
                            setLoading(false);
                        }
                    })
                    .catch((err) => {
                        setLog('Неизвестная ошибка!');
                        setLoading(false);
                        ErrorAdd(err, window.location.href);
                    });
            }
            //Обновляем файлы
            for (let i = 0; i < files_update.length; i++) {
                axios.post('/api_tracker/board/taskWidgetFileUpdate', { ID: files_update[i].ID_File, Name: files_update[i].Name, ID_Board_Task: idTask })
                    .then((res) => {
                        if (res.data.Status === 1) {

                        }
                        else {
                            setLog(res.data.Error);
                            setLoading(false);
                        }
                    })
                    .catch((err) => {
                        setLog('Неизвестная ошибка!');
                        setLoading(false);
                        ErrorAdd(err, window.location.href);
                    });
            }

            //Удаляем файлы
            for (let i = 0; i < files_remove.length; i++) {
                axios.post('/api_tracker/board/taskWidgetFileRemove', { ID: files_remove[i].ID_File, ID_Board_Task: idTask })
                    .then((res) => {
                        if (res.data.Status === 1) {

                        }
                        else {
                            setLog(res.data.Error);
                            setLoading(false);
                        }
                    })
                    .catch((err) => {
                        setLog('Неизвестная ошибка!');
                        setLoading(false);
                        ErrorAdd(err, window.location.href);
                    });
            }

            //Обновление сортировки
            const items = files.filter(a => a.ID_File !== null).map((item) => { return { ID_File: item.ID_File, Order: item.Order } })

            axios.post('/api_tracker/board/taskWidgetFileOrderChange', { ID_Board_Task: idTask, Widget_Number: number, Items: items })
                .then((res) => {
                    if (res.data.Status === 1) {

                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });

            setLoading(false);
            setEdit(false);
        }

        //Обновляем настройки виджета
        widgetUpdateHandler();
    }

    //Изменение сортировки
    function moveFile({ dragIndex, hoverIndex }) {

        const list_new = immutabilityUpdate(files, {
            $splice: [
                [dragIndex, 1],
                [hoverIndex, 0, files[dragIndex]],
            ],
        })

        const list_new_order = list_new.map((item, index) => {
            return { ...item, Order: index };
        });

        setFiles(list_new_order)
    }


    return (
        <div>
            {files.length === 0 && (
                <div className="text-center">
                    <SrvButton typeBtn='add' size='lg' textBtn="Добавить файл" onClick={() => setEdit(true)} />
                </div>
            )}
            {files.length > 0 &&
                <div className='card_widget_body'>
                    {onlyRead !== true && (
                        <div className="card_widget_btn_edit mt-0">
                            <SrvButtonLink typeBtn="edit" textBtn="" onClick={() => setEdit(true)} />
                        </div>
                    )}
                    {files.filter(a => a.ID_File !== null).sort((a, b) => a.Order - b.Order).map((item) => (
                        <WidgetFileItem key={item.ID_File} model={item} idObject={idObject} />
                    ))}
                </div>
            }
            {edit === true &&
                (
                    <Modal show={edit} onHide={() => setEdit(false)} >
                        <Modal.Body>
                            <div className="modal_close" onClick={() => setEdit(false)}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                            <div className="modal_title text-center">Файлы</div>
                            <BlockName name={name} setName={nameChange} updateHandler={widgetUpdateHandler} />
                            <div className='mt-15'>
                                {[...files].map((item, index) => (
                                    <WidgetFileItemEdit key={item.temp_id} number={number} index={index} model={item} loading={loading} changeHandler={changeNameHandler} removeHandler={changeRemoveHandler} removeCancelHandler={changeRemoveCancelHandler} moveFile={moveFile} />
                                ))}
                            </div>
                            <div className='row mt-25'>
                                <div className='col-md-12 text-center'>
                                    <FileUploader handleChange={(files) => changeFileHandler(files)} multiple={true} label={'Выберите файлы'} maxSize={28} onSizeError={() => setLog("Превышен максимальный размер 1 файла 28мб")} onSelect={() => setLog(null)} />
                                </div>
                            </div>
                            {idObject === 2 && (
                                <div className="mt-15">
                                    <Form.Check // prettier-ignore
                                        type="switch"
                                        id="show_tracker_switch"
                                        label="Отображать в «Текущих задачах?»"
                                        defaultChecked={showTracker}
                                        onChange={(e) => showTrackerChange(e.target.checked)}
                                    />
                                </div>
                            )}
                            {log !== null && (<div className="form_error">{log}</div>)}
                            <div className='row mt-15'>
                                <div className='col-md-12 text-center'>
                                    <SrvButton typeBtn='save' size='lg' onClick={updateHandler} loading={loading} />
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                )
            }
            {log !== null && <div className="form_error text-center">{log}</div>}
        </div>
    )
}

export default WidgetFile;